import { render, staticRenderFns } from "./SecondaryMenu.vue?vue&type=template&id=891cc0fe&scoped=true&"
import script from "./SecondaryMenu.vue?vue&type=script&lang=js&"
export * from "./SecondaryMenu.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryMenu.vue?vue&type=style&index=0&id=891cc0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891cc0fe",
  null
  
)

export default component.exports